import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Index } from './pages/index/index';
import { LoginComponent } from './pages/login/login';
import { ResetPasswordComponent } from './pages/reset-password/reset-password'; 
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideLucideIcons } from '@lucide/angular';
import { DashboardLayout } from './pages/dashboard/dashboard-layout/dashboard-layout';
import { Sidebar } from './components/sidebar/sidebar';
import { Overview } from './pages/dashboard/overview/overview';
import { Subjects } from './pages/dashboard/subjects/subjects';
import { AuthInterceptor } from './helpers/Auth.Interceptor';
import { LoaderComponent } from './components/ui/loader-component/loader-component';
import { SubjectOfferings } from './pages/dashboard/subject-offerings/subject-offerings';
import { AcademicYears } from './pages/dashboard/academic-years/academic-years';
import { ContentPublisher } from './pages/dashboard/content-publisher/content-publisher';
import { ActivationCodeManager } from './pages/dashboard/activation-code-manager/activation-code-manager';
import { NotFoundComponent } from './pages/not-found/not-found';
import { ForbiddenComponent } from './pages/forbidden/forbidden';

@NgModule({
  declarations: [
    App,
    Index,
    LoginComponent,
    ResetPasswordComponent,
    DashboardLayout,
    Sidebar,
    Overview,
    Subjects,
    LoaderComponent,
    SubjectOfferings,
    AcademicYears,
    ContentPublisher,
    ActivationCodeManager,
    NotFoundComponent,
    ForbiddenComponent,
  ], 
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideLucideIcons()
  ],
  bootstrap: [App],
})
export class AppModule {}